import AppVersionList from '../../slices/app_version/AppVersionList'

const appVersionReducer = {
    appVersionList: AppVersionList,
};

export default appVersionReducer;
